import script from "./fileModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./fileModal.vue?vue&type=script&setup=true&lang=ts"

import "./fileModal.vue?vue&type=style&index=0&id=7f438814&lang=scss"

const __exports__ = script;

export default __exports__